export default () => ({
  id: null,
  isGlobal: false,
  automationInterfaceId: null,
  automationInterfaceType: null,
  configuredAutomationInterface: null,
  loadedAutomationInterface: false,
  automationResults: [],
  fetchingAutomationResults: false,
  automationResultsPagination: null,
  searchables: [],
  searchablesPagination: null,
});
